import axios from 'axios';
import { toast } from 'react-toastify';

const basePathV1 = `${process.env.REACT_APP_API_URL}/v1`;

export const addHighlight = (data) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.post(
      `${basePathV1}/highlight`, data, config,
    );

    return res.data;
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const editHighlight = (id, data) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.put(
      `${basePathV1}/highlight/${id}`, data, config,
    );

    return res.data;
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const editHighlights = (highlights) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.put(
      `${basePathV1}/highlights`, { highlights }, config,
    );
    if (res.status == 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const updateDisplayOrder = (order) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.put(
      `${basePathV1}/highlights/displayOrder`, { order }, config,
    );
    if (res.status === 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const deleteHighlight = (id) => async (dispatch) => {
  try {
    const config = {
      validateStatus(status) { return status < 500; },
    };
    const res = await axios.delete(
      `${basePathV1}/highlight/${id}`, config,
    );
    if (res.status == 200) {
      toast.success('Highlight deleted.');
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};
